var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSslShield = function SvgSslShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.32 8.62-3.25 3.25-1.38-1.38a.706.706 0 0 0-.99 0c-.27.27-.27.72 0 .99l1.88 1.87c.14.14.32.21.5.21s.36-.07.5-.21l3.75-3.75c.27-.27.27-.72 0-.99a.706.706 0 0 0-.99 0l-.02.01Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.72 4.21c-.31-.31-.72-.48-1.16-.48-1.6 0-3.76-.95-5.4-2.38-.65-.55-1.68-.56-2.34 0-1.63 1.42-3.79 2.38-5.39 2.38-.44 0-.85.17-1.16.48-.31.31-.48.72-.48 1.16v6.56c0 4.3 2.51 7.26 7.64 9.03.18.07.38.1.57.1.18 0 .36-.03.53-.09 5.15-1.79 7.65-4.75 7.65-9.05V5.36c0-.44-.17-.85-.48-1.16l.02.01Zm-.92 7.72c0 3.68-2.13 6.13-6.71 7.73-.05.02-.1.02-.17 0-4.58-1.58-6.72-4.03-6.72-7.72V5.38c0-.06.02-.12.07-.17.04-.05.1-.07.17-.07 1.94 0 4.42-1.07 6.3-2.72a.4.4 0 0 1 .26-.1c.1 0 .19.03.25.09 1.89 1.65 4.37 2.72 6.31 2.72.06 0 .12.02.17.07.04.04.07.1.07.17v6.56Z",
    fill: "currentColor"
  })));
};
export default SvgSslShield;